<template>
  <v-simple-table>
    <template>
      <tbody>
        <tr>
          <td>
            <strong>{{ $t("reportSummary.finalResult") }}</strong>
          </td>
          <td>
            <strong>{{ fund.report.stars }} {{ $tc("report.stars", fund.report.stars) }}</strong>
          </td>
          <td v-if="audit"></td>
          <td v-if="audit">
            <BaseNumeral :number="fund.report.perc" format="0%" />
          </td>
        </tr>
        <tr v-for="category in fund.report.categoriesWithStars" :key="category.category">
          <td>
            {{ $t(`stepModelRequirementCategory.${category.category}.name`) }}
          </td>
          <td>
            {{ category.stars }}
            {{ $tc("report.stars", category.stars) }}
          </td>
          <td v-if="audit">{{ category.points }} / {{ category.maxPoints }}</td>
          <td v-if="audit">
            <BaseNumeral :number="category.perc" format="0%" />
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: "StepModelRequirementsSummaryTable",

  props: {
    fund: {
      type: Object,
      required: true,
    },

    audit: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
